import React from "react";

/**
 * Section header — mono eyebrow, Syne display title, optional right-side
 * index number. Left-aligned editorial composition, never generic centered.
 */
export function SectionHead({ eyebrow, title, index, children, className = "" }) {
  return (
    <div className={`mb-10 sm:mb-14 ${className}`}>
      <div className="flex items-baseline justify-between gap-6">
        {eyebrow && (
          <p className="font-mono-lux text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase text-[#F26522]">
            {eyebrow}
          </p>
        )}
        {index && (
          <p className="font-mono-lux text-xs sm:text-sm tracking-[0.25em] text-zinc-400" aria-hidden="true">
            {index}
          </p>
        )}
      </div>
      <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight text-white leading-[1.1]">
        {title}
      </h2>
      {children && <div className="mt-4 max-w-2xl text-zinc-300 text-base sm:text-lg">{children}</div>}
      <div className="rule-lux mt-6" aria-hidden="true" />
    </div>
  );
}
